import { all } from "redux-saga/effects";

export function* linkListWorker() {
  yield all([]);
}
